"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class SubSup extends mark_1.Mark {
    constructor(variant) {
        super('subsup');
        this.variant = variant;
    }
    toJSON() {
        return {
            type: this.type,
            attrs: {
                type: this.variant
            }
        };
    }
}
exports.SubSup = SubSup;
//# sourceMappingURL=subsup.js.map